export default "__VITE_ASSET__cj6G3rjG__"